import React from 'react'

const ExportMyHRIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M44.5 1.1C25.1 5.1 9.3 19 2.8 37.9L.5 44.6v423l2.3 6.6c5.7 16.6 18.5 29.4 35 35.1l6.7 2.3h301l6.7-2.3c16.4-5.7 28.6-17.8 35-34.8l2.3-5.9.3-88.7.3-88.8h70.4l-17.7 17.8c-9.7 9.7-18.3 19.1-19.2 20.9-3.4 6.9-.5 15.8 6.4 19.3 4.9 2.5 9 2.5 13.8.1 4.6-2.4 64.4-62.4 66.6-66.8.9-1.8 1.6-4.6 1.6-6.3 0-1.7-.7-4.5-1.6-6.3-2.2-4.4-62-64.4-66.6-66.8-4.8-2.4-8.9-2.4-13.8.1-6.9 3.5-9.8 12.4-6.4 19.3.9 1.8 9.5 11.2 19.2 20.9l17.7 17.8H390v-74.5c0-66.3-.2-75-1.6-77.8-2.2-4.4-102-104.4-106.6-106.8C278.2.2 274.9.1 163.3.2c-63.1.1-116.6.5-118.8.9zm215.5 73c0 42.2.1 44.2 2 48 1.3 2.6 3.4 4.7 6 6 3.8 1.9 5.8 2 48 2h44v131h-53c-51.2 0-53.2.1-57 2-4.5 2.3-8 8-8 13s3.5 10.7 8 13c3.8 1.9 5.8 2 57 2h53v84.8c0 95.5.4 90.9-7.5 98.7-8 8.1 3.9 7.5-157.5 7.5s-149.5.6-157.5-7.5c-8.2-8.1-7.5 11.2-7.5-218.5 0-229.8-.7-210.4 7.5-218.5 7.7-7.8.5-7.3 117.8-7.4l104.7-.1v44zm54.5 2l24 24H290v-24c0-13.2.1-24 .3-24 .1 0 11 10.8 24.2 24z"
      />
      <text
        fill={color}
        x="-1.756"
        y="220.581"
        stroke="null"
        strokeWidth="0"
        fontFamily="sans-serif"
        fontSize="50"
        fontWeight="bold"
        transform="rotate(-89.947 -40.526 462.534) scale(2.29617 3.14784)"
      >
        MyHR
      </text>
    </svg>
  )
}

ExportMyHRIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default ExportMyHRIcon
